import React, { useState, useEffect } from "react";
import DropdownRight from "./DropdownRight";
import Nav from "../components/Nav";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";
import CsvDownload from "react-json-to-csv";
import ReactPaginate from "react-paginate";
import moment from "moment";

const ViewLogs = () => {
  const token = localStorage.getItem("xAuthToken");
  const [viewlog, setViewLog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [toExport, setToExport] = useState([]);
  const [isMore, setIsMore] = useState(true);
  const [total, setTotal] = useState(0);
  const changePage = ({ selected }) => {
    Viewlogs(selected);
  };
  const Viewlogs = async (page = 0) => {
    setLoading(true);

    http
      .get(`api/admin/view_logs?page=${page}&token=${token}`)
      .then((res) => {
        console.log("response----->", res.data.views);
        setToExport(res.data.views);
        setViewLog(res.data.views);
        setIsMore(res.data.isMore);
        setTotal(res.data.total);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const usersPerPage = 10;

  const pageCountAnalyst = Math.ceil(total / usersPerPage);

  useEffect(() => {
    Viewlogs();
  }, []);

  return (
    <>
      <div class="wrapper">
        <Nav />
        <div id="content">
          <header>
            <div class="dashboard_header">
              <div class="left-side d-flex ">
                {" "}
                <button
                  type="button"
                  id="sidebarCollapse"
                  class="btn btn-link bt_none"
                >
                  <i class="fa fa-align-left"></i>{" "}
                </button>
                <h1>View Video</h1>
                <h6 style={{ color: "red" }}>{error}</h6>
              </div>
              <div class="user_profile   ">
                <DropdownRight />
              </div>
            </div>
          </header>
          <div class="dashbord_content">
            <div class="analysts-wraper-head">
              <div class="form-group search_wraper"></div>
              <div class="map_btn" style={{ marginBottom: 30 }}>
                <CsvDownload data={toExport} className="them_btn">
                  Export
                </CsvDownload>
              </div>
            </div>
            <div class="table_vedio_upload dashbord_table    team_table mb_30 over_flow mb-0">
              <table class="table table-borderless table-responsive-md">
                <thead>
                  <tr>
                    {/* <th scope="col" class="  pl_25">
                      Video
                    </th> */}
                    <th scope="col" class=" ">
                      Video 1
                    </th>
                    <th scope="col" class=" ">
                      Video 2
                    </th>
                    <th scope="col" class=" ">
                      Viewer_Contact
                    </th>
                    <th scope="col" class=" ">
                      Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <div
                      style={{
                        position: "absolute",
                        marginTop: 100,
                        marginLeft: 580,
                        zIndex: 100,
                      }}
                    >
                      <SpinnerCircular size="15%" />
                    </div>
                  ) : (
                    ""
                  )}
                  {viewlog?.map((item) => (
                    <tr>
                      <td style={{ wordBreak: "break-all" }}>{item.video1}</td>
                      <td>{item.video2}</td>
                      <td>{item.viewer_contact}</td>
                      <td>
                        {" "}
                        {moment(item.created_at).format("hh:mm:ss A")} <br />
                        {moment(item.created_at).format("MMM Do YY")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="pagination">
            <div className="paginateText">
              <p className="text-table-show">
                {" "}
                Showing {viewlog.length} out of {total} entries
              </p>
            </div>
            <div className="reactPaginate">
              <ReactPaginate
                previousLabel={"<<"}
                nextLabel={">>"}
                pageCount={pageCountAnalyst}
                onPageChange={changePage}
                containerClassName={"paginationBttns"}
                previousLinkClassName={"previousBttn"}
                nextLinkClassName={"nextBttn"}
                disabledClassName={!isMore ? "paginationDisabled" : ""}
                activeClassName={"paginationActive"}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewLogs;
